import { render } from "./NewEventModal.vue?vue&type=template&id=a9a8bdba&ts=true"
import script from "./NewEventModal.vue?vue&type=script&lang=ts"
export * from "./NewEventModal.vue?vue&type=script&lang=ts"

import "./NewEventModal.vue?vue&type=style&index=0&id=a9a8bdba&lang=scss"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__